import moment from "moment";
import { convertoHtml, decryptData } from "./helpers";

export const getHeader = (patient, lookup) => {
  return `
  <div style="display: flex; justify-content: space-between;"><img style="width:13rem;" src="https://family-health.sgp1.digitaloceanspaces.com/1600671898685%20-%20Group%2084.png"/> <img style="width:14rem;" src="https://family-health.sgp1.digitaloceanspaces.com/1686224841557%20-%20logo%201.png"/></div>
<hr>
<div class="truncate" style="display: flex; justify-content: space-between; flex-wrap: wrap; margin: 0 20px;">
<div class="truncate">
   <p style="margin:5px;"><strong>Patient's Name:</strong> ${patient.name}${
    patient.fatherOrHusbandName ? "/" + patient.fatherOrHusbandName : ""
  } 
   </p>
</div>
<div>
   <p style="margin:5px;"><strong>Age/Sex:</strong> ${patient.age}/${
    patient.gender == 1 ? "M" : patient.gender == 2 ? "F" : ""
  }
   </p>
</div>
<div style="min-width:150px;text-align:left;">
   <p style="margin:5px;"><strong>Registered On:</strong> ${moment(
     lookup.performed_on
   )
     .utc()
     .format("DD-MM-YYYY, h:mm A")}
   </p>
</div>
<div style="display: flex;width:100%; justify-content: space-between; flex-wrap: wrap;">
   <div>
      <p style="margin:5px;"><strong>Reffered By:</strong> ${
        patient && patient.referredBy ? patient.referredBy : ""
      } ${lookup.description ? "(" + lookup.description + ")" : ""}
      </p>
   </div>
   <div style="min-width:150px;text-align:left;">
      <p style="margin:5px;"><strong>MR#:</strong> ${patient &&
        patient.mr_no.slice(3)}
      </p>
   </div>
   <div style="min-width:150px;text-align:left;">
      <p style="margin:5px;"><strong>Reported On:</strong> ${moment().format(
        "DD-MM-YYYY, h:mm A"
      )}
      </p>
   </div>
</div>
`;
};

export const getFooter = settings => {
  return `<footer class="footer" style="text-align: center; margin: 0;">
  <div>
  ${settings.note ? convertoHtml(settings.note) : ""}
  <hr>
  ${settings.footer ? convertoHtml(settings.footer) : ""}
  </div>
  <footer/>`;
};

export const createPdfContnets = (header, body, footer, desc) => {
  const user = decryptData(
    localStorage.getItem("userInfo"),
    process.env.VUE_APP_SECRET_KEY
  );
  const description =
    user.description && user.description.length > 0
      ? user.description.split(".")
      : [];
  return `
  <!DOCTYPE html>
  <html>
    <head>
        <style>
          @import url(https://fonts.googleapis.com/css?family=Signika);
          body {
          font-family: 'Signika', sans-serif;
          }
          p {
          font-weight: normal;
          font-size: 14px;
          line-height: 18px;
          }
          .header, .header-space {
          height: ${desc ? (desc.length > 15 ? "205px" : "180px") : "180px"};
          }
          .footer, .footer-space {
          height: 120px;
          }
          .header {
          position: fixed;
          top: 0;
          }
          .content {
            margin-bottom: 20px;
            margin-top: -2rem !important;
          }
          .footer {
          position: fixed;
          margin: 0;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          }
          footer p, h1, h2, h3, h4, h5, em {
            margin: 0;
          }
          @media print {
          thead { display: table-header-group; }
          tfoot { display: table-footer-group; }
          }
          @media screen {
          thead { display: block; }
          tfoot { display: block; }
          }
        </style>
    </head>
    <body>
        <div>
        <table>
          <thead>
              <tr>
                <td>
                    <div class="header-space"> </div>
                </td>
              </tr>
          </thead>
          <tbody>
              <tr>
                <td>
                    <div class="content">
                    ${body}
                    <div style="margin-top: 40px;">
                      <strong style="text-transform: capitalize;">Dr. ${user &&
                        user.full_name}</strong>
                      <p style="text-align: left; margin: 0;">${description[0] ||
                        ""}
                      </p>
                      <p style="text-align: left; margin: 0;">${description[1] ||
                        ""}</p>
                      <div />
                      </div>
                </td>
              </tr>
          </tbody>
          <tfoot>
          <tr><td>
          <div class="footer-space"> </div>
          </td></tr>
          </tfoot>
        </table>
        <div class="header">${header}</div>
        <hr>
        <div class="footer">${footer}</div>
        </div>
    </body>
  </html>
  `;
};
